import { MetaType, ROBOTS } from '@lmp/eduki-routes';

export const LANGUAGE_COLUMN_COUNT = 5;

export const DROPDOWN_COLORS = {
    BORDER: '#797979',
    BORDER_FOCUS: '#26bfbf',
    TEXT: '#262626',
    OPTION_SELECTED: '#a8e5e5',
    OPTION_FOCUSED: '#eefafa',
    WHITE: '#ffffff'
} as const;

export const metaData: MetaType = {
    auto: { ograph: true },
    robots: ROBOTS.INDEX_FOLLOW,
    description:
        'eduki: Teaching materials created by teachers for teachers ✅ all subjects, levels and languages ✅ share/sell your materials to other teachers',
    title: 'eduki: 👩‍🏫 teaching materials - share and find materials'
};
